// Shared signed-PDF markup helpers for registry components. Inline styles
// only: the PDF renderers inject this markup into standalone page HTML.
import { decodeHtmlEntities, escapeHtml } from './attributeParsing.js';
/** The label to render on PDF paths: always the untranslated source label. */
export const pdfLabelFor = (field) => field.originalLabel || field.label;
/**
 * Render a labeled value box: bold label above a bordered value container.
 * `valueHtml` is raw markup and must already be escaped by the caller.
 */
export const renderLabeledValuePdfHtml = (label, valueHtml) => `<div style="margin:12px 0;">
    <div style="font-weight:600;font-size:14px;margin-bottom:6px;color:#1e293b;">${escapeHtml(decodeHtmlEntities(label))}</div>
    <div style="font-size:14px;color:#1e293b;border:1px solid #cbd5e1;border-radius:6px;padding:8px 10px;background:#f8fafc;min-height:20px;">${valueHtml}</div>
  </div>`;
